import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import { useLocation, useNavigate } from "react-router-dom";
import { getData, postData } from "../Commonfunction/CommonFunction";
import TopHeading from "../common/TopHeading";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importing toast styles
import "../../assets/style/Employees.css";
import { GoPasskeyFill } from "react-icons/go";

export default function CpaListing() {
  const [tableData, setTableData] = useState();
  const [open, setOpen] = useState(false);
  const [rowId, setRowId] = useState();
  const navigate = useNavigate();
  const handlePermission = (id) => {
    navigate("/role/cpa/permission/" + id);
  };
  const fetchData = async () => {
    try {
      const result = await getData("/api/all-cpc");
      if (result.success) {
        setTableData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const indexedRows =
    tableData?.length > 0 &&
    tableData?.map((data, index) => ({
      index: index + 1,
      id: data.id,
      company_name: data?.company_name,
      dba_name: data?.dba_name,
      mobile_no: data?.mobile_no,
      email: data?.email,
      gst_ein_number: data?.gst_ein_number,
    }));
  useEffect(() => {
    fetchData();
  }, []);
  const columns = [
    { key: "index", label: "No", sortable: true },

    {
      key: "action",
      label: "Action",
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="edit-btn"
              onClick={() => {
                navigate(`/edit-cpa/${params?.id}`, {
                  state: params?.id,
                });
              }}
            >
              <TbEdit size={22} />
            </button>
            <button
              className="delete-btn"
              onClick={() => {
                setOpen(true), setRowId(params.id);
              }}
            >
              <RiDeleteBin6Line size={22} />
            </button>
            <button
              className="action-button download"
              onClick={() => handlePermission(params.id)}
            >
              <GoPasskeyFill size={22} />
            </button>
          </div>
        </div>
      ),
    },

    { key: "company_name", label: "CPA", sortable: true },
    { key: "dba_name", label: "DBA Name", sortable: true },
    { key: "mobile_no", label: "Mobile Number", sortable: true },
    { key: "email", label: "Email", sortable: true },
    { key: "gst_ein_number", label: "EIN", sortable: true },
  ];

  return (
    <div className="usa-prose">
      <TopHeading
        heading="CPA"
        path={"/add-cpa"}
        isHideBtn={true}
        csvFileUpload={false}
        csvName="Add Employee By CSV"
      />

      <CommonTable columns={columns} data={indexedRows || []} />
      {open == true && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-cpc/${rowId}`}
          getApi={fetchData}
        />
      )}
    </div>
  );
}
